import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Notification {
  id: number;
  type: "success" | "info" | "error";
  title: string;
  message?: string;
  icon: string;
}

interface NotificationState {
  queue: Notification[];
}

const initialState: NotificationState = {
  queue: [],
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.queue.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.queue = state.queue.filter((n) => n.id !== action.payload);
    },
  },
});

export const { addNotification, removeNotification } = notificationsSlice.actions;
export default notificationsSlice.reducer;
